angular.module('portal.i18n').factory('i18nUtils', [
    '$window',
    'AvailableLanguages',
    'DefaultLanguage',
    'AvailableLocales',
    'DefaultLocale',
    function i18nUtilsProvider($window, AvailableLanguages, DefaultLanguage, AvailableLocales, DefaultLocale) {
        return {
            /**
             * Normalize language code
             *
             * @param {string} langCode Language code
             *
             * @returns {string} Normalized language code
             */
            normalizeLangCode: function normalizeLangCode(langCode) {
                // Para ser un código ISO 639-1 válido debe estar expresado en minúsculas
                var cleanLangCode = langCode.split('-', 2)[0].toLowerCase();

                // Y debe ser uno de los idiomas soportados
                return AvailableLanguages.indexOf(cleanLangCode) > -1 ? cleanLangCode : DefaultLanguage;

            },
            /**
             * Normalize locale
             *
             * @param {string} locale Locale
             *
             * @returns {string} Normalized locale
             */
            normalizeLocale: function normalizeLocale(locale) {
                var normalizedLocale;

                // Valores por defecto para locales sin código de país
                if (locale === 'es') {
                    normalizedLocale = 'es_ES';
                }
                else if (locale === 'en') {
                    normalizedLocale = 'en_GB';
                }
                else if (locale === 'de') {
                    normalizedLocale = 'de_DE';
                }
                else if (locale === 'pt') {
                    normalizedLocale = 'pt_PT';
                }
                else {
                    var langParts = locale.split(/[-_]/, 2);
                    var langCode = langParts[0].toLowerCase();
                    var countryCode = langParts[1].toUpperCase();

                    if (langCode === 'es') {
                        normalizedLocale = 'es_ES';
                    }
                    else if (langCode === 'en') {
                        if (['GB', 'US'].indexOf(countryCode) === -1) {
                            countryCode = 'GB';
                        }
                        normalizedLocale = 'en_' + countryCode;
                    }
                    else if (langCode === 'de') {
                        normalizedLocale = 'de_DE';
                    }
                    else if (langCode === 'pt') {
                        normalizedLocale = 'pt_PT';
                    }
                }

                // Debe ser uno de los soportados, por defecto "en_GB"
                return normalizedLocale && AvailableLocales.indexOf(normalizedLocale) > -1 ? normalizedLocale : DefaultLocale;
            },
            /**
             * Get browser language
             *
             * @returns {string} Browser language
             *
             * @see https://stackoverflow.com/a/29106129
             */
            getFirstBrowserLanguage: function getFirstBrowserLanguage() {
                var navigator = $window.navigator;

                // Default language: english
                var language = DefaultLanguage;

                // Available languages in regex - https://developer.mozilla.org/es/docs/Web/API/NavigatorLanguage/language
                var regex = new RegExp('^(' + AvailableLanguages.join('|') + ')(-[a-z]{2})?', 'i');

                var index, matches, candidateLanguage;
                // support for HTML 5.1 "navigator.languages"
                if (Array.isArray(navigator.languages)) { // eslint-disable-line angular/typecheck-array
                    for (index = 0; index < navigator.languages.length; index++) {
                        candidateLanguage = navigator.languages[index];
                        if (candidateLanguage && candidateLanguage.length && (matches = regex.exec(candidateLanguage)) !== null) {
                            language = matches[0];
                            break;
                        }
                    }
                }
                else {
                    // support for other well known properties in browsers
                    var browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'];
                    for (index = 0; index < browserLanguagePropertyKeys.length; index++) {
                        candidateLanguage = navigator[browserLanguagePropertyKeys[index]];
                        if (candidateLanguage && candidateLanguage.length && (matches = regex.exec(candidateLanguage)) !== null) {
                            language = matches[0];
                            break;
                        }
                    }
                }

                return language;
            },
            /**
             * Normalize locale to configure momentJs
             *
             * @param {string} locale Locale
             *
             * @returns {string} Moment locale
             */
            normalizeMomentLocale: function normalizeMomentLocale(locale) {
                var momentLocale = locale.replace('_', '-').toLowerCase();

                if (momentLocale === 'es-es') {
                    momentLocale = 'es';
                }
                else if (momentLocale === 'en-us') {
                    momentLocale = 'en';
                }
                else if (momentLocale === 'de-de') {
                    momentLocale = 'de';
                }
                else if (momentLocale === 'pt-pt') {
                    momentLocale = 'pt';
                }

                return momentLocale;
            },
        };
    },
]);
